// ** React Imports ** //
import React, { Fragment } from "react";
import "@/styles/layout/wrapper.scss";

// ** Component Imports ** //
import Header from "@/layout/Header";
import Footer from "@/layout/Footer";

const Wrapper = ({ children }) => {
  return (
    <Fragment>
      <Header />
      <div className="wrapper">{children}</div>
      <Footer />
    </Fragment>
  );
};

export default Wrapper;
